/**
 * Os termos de uso e a política de privacidade num diálogo (docs/spec/termos.md), com uma aba para
 * cada: o cadastro e o aviso de novo aceite abrem aqui, sem sair do formulário. O texto é o mesmo das
 * páginas `/termos` e `/privacidade`.
 */
import { useRef, useState } from 'react';
import { useLanguage, useT } from '../i18n/index.js';
import type { LegalDoc } from '../legal/documents.js';
import { LegalDocument } from '../legal/LegalDocument.js';
import { Button, Dialog, Segmented } from '../ui/controls.js';

export function TermsDialog({ initial = 'terms', onClose }: { initial?: LegalDoc; onClose: () => void }) {
  const t = useT();
  const language = useLanguage((s) => s.language);
  const [doc, setDoc] = useState<LegalDoc>(initial);
  const top = useRef<HTMLDivElement>(null);
  const show = (next: LegalDoc) => {
    setDoc(next);
    // o corpo do diálogo rola: a outra aba começa do alto
    top.current?.closest('.rd-dialog__body')?.scrollTo({ top: 0 });
  };
  return (
    <Dialog
      title={t(`legal.${doc}.title`)}
      onClose={onClose}
      className="rd-legal__dialog"
      actions={
        <Button variant="action" onClick={onClose}>
          {t('common.close')}
        </Button>
      }
    >
      <div ref={top}>
        <Segmented<LegalDoc>
          value={doc}
          onChange={show}
          aria-label={t('legal.nav')}
          options={[
            { value: 'terms', label: t('legal.terms.short') },
            { value: 'privacy', label: t('legal.privacy.short') },
          ]}
        />
        <LegalDocument doc={doc} language={language} variant="dialog" onNavigate={show} />
      </div>
    </Dialog>
  );
}
